<template>
  <div class="settings--content">
    <settings-section :title="$t('INBOX_MGMT.BUSINESS_HOURS.TITLE')"
      :sub-title="$t('INBOX_MGMT.BUSINESS_HOURS.SUBTITLE')">
      <form @submit.prevent="updateInbox">
        <label for="toggle-business-hours" class="toggle-input-wrap">
          <input v-model="isBusinessHoursEnabled" type="checkbox" name="toggle-business-hours" />
          {{ $t('INBOX_MGMT.BUSINESS_HOURS.TOGGLE_AVAILABILITY') }}
        </label>
        <p>{{ $t('INBOX_MGMT.BUSINESS_HOURS.TOGGLE_HELP') }}</p>
        <div v-if="isBusinessHoursEnabled" class="business-hours-wrap">
          <label class="unavailable-input-wrap">
            {{ $t('INBOX_MGMT.BUSINESS_HOURS.UNAVAILABLE_MESSAGE_LABEL') }}
            <label v-if="isCloseToLimit && !isMoreThanMax" class='message-length'>{{ charToLimit }} {{ $t('INBOX_MGMT.BUSINESS_HOURS.CLOSE_CHARACTER') }}</label>
            <label v-if="isMoreThanMax" class='message-error'>{{ charOverLimit }} {{ $t('INBOX_MGMT.BUSINESS_HOURS.OVER_CHARACTER') }}</label>
            <label v-if="isRichEditorEnabled" class="richtext">
              <woot-message-editor v-model="unavailableMessage" :enable-variables="true" :is-format-mode="true"
                class="input" :min-height="4" />
            </label>
            <textarea v-else v-model="unavailableMessage" type="text" />
          </label>

          <div class="timezone-input-wrap">
            <label>
              {{ $t('INBOX_MGMT.BUSINESS_HOURS.TIMEZONE_LABEL') }}
            </label>
            <multiselect v-model="timeZone" :options="timeZones" deselect-label="" select-label="" selected-label=""
              track-by="value" label="label" :close-on-select="true"
              :placeholder="$t('INBOX_MGMT.BUSINESS_HOURS.DAY.CHOOSE')" :allow-empty="false" />
          </div>

          <label for="toggle-define-business-hours" class="toggle-input-wrap">
            <input v-model="enableWeekly" type="checkbox" name="toggle-define-business-hours" @change="handleDefineBusinessHoursToggle" />
   {{ $t('INBOX_MGMT.BUSINESS_HOURS.WEEKLY_TITLE') }}
 </label>

          <div v-if="enableWeekly">
            <business-day v-for="timeSlot in timeSlots" :key="timeSlot.day" :day-name="dayNames[timeSlot.day]"
              :time-slot="timeSlot" :is-custom-date="true" @update="data => onSlotUpdate(timeSlot.day, data)" />
          </div>
            <div class="separator">
          <label for="toggle-business-hours" class="toggle-input-wrap">
            <input v-model="isBusinessHoursDisableBot" type="checkbox" name="toggle-business-hours" />
            {{ $t('INBOX_MGMT.BUSINESS_HOURS.TOGGLE_BOT_AVAILABILITY') }}
          </label>

          <label for="toggle-define-custom-business-hours" class="toggle-input-wrap" style="margin-top: 1rem;">
            <input v-model="isDefineCustomBusinessHoursEnabled" type="checkbox" name="toggle-define-custom-business-hours" />
            {{ $t('INBOX_MGMT.BUSINESS_HOURS.CUSTOM_DATE_TITLE') }}
          </label>

          <div v-if="isDefineCustomBusinessHoursEnabled">
            <custom-business-day v-for="customSlot in customTimeSlots" :key="customSlot.id" :day-name="customSlot.dayName"
              :time-slot="customSlot" @update="data => onCustomSlotUpdate(customSlot.id, data)" @delete="() => onCustomSlotDelete(customSlot.id)" />
          </div>
        </div>
          <woot-submit-button v-if="isDefineCustomBusinessHoursEnabled" :button-text="$t('INBOX_MGMT.BUSINESS_HOURS.ADD_CUSTOM_DATE_LABEL')" :type="'button'"
            :disabled="hasError || isMoreThanMax" @click="(e) => addCustomTimeSlot(e)" class="add-button" />

          <div class="separator" style="margin-top: 2rem;">
            <label for="toggle-re-engagement" class="toggle-input-wrap">
              <input v-model="reEngagementActive" type="checkbox" name="toggle-re-engagement" />
              {{ $t('INBOX_MGMT.BUSINESS_HOURS.RE_ENGAGEMENT.TOGGLE') }}
            </label>
            <p>{{ $t('INBOX_MGMT.BUSINESS_HOURS.RE_ENGAGEMENT.TOGGLE_HELP') }}</p>

            <div v-if="reEngagementActive" style="margin-top: 1rem;">
              <label class="unavailable-input-wrap">
                {{ $t('INBOX_MGMT.BUSINESS_HOURS.RE_ENGAGEMENT.MESSAGE_LABEL') }}
                <textarea v-model="reEngagementMessage" type="text" :placeholder="$t('INBOX_MGMT.BUSINESS_HOURS.RE_ENGAGEMENT.MESSAGE_PLACEHOLDER')" />
              </label>

              <div v-if="isWhatsAppInbox" style="margin-top: 1.5rem;">
                <label>{{ $t('INBOX_MGMT.BUSINESS_HOURS.RE_ENGAGEMENT.TEMPLATE_LABEL') }}</label>

                <div v-if="reEngagementMessageTemplate" class="template-selected">
                  <div class="template-info">
                    <strong>{{ reEngagementMessageTemplate.template_params.name }}</strong>
                    <span class="template-lang">{{ reEngagementMessageTemplate.template_params.language }}</span>
                  </div>
                  <button type="button" @click="clearTemplate" class="clear-template-button">
                    <fluent-icon icon="dismiss" size="14" />
                  </button>
                </div>

                <woot-submit-button
                  v-if="!showTemplatePicker && !reEngagementMessageTemplate"
                  :button-text="$t('INBOX_MGMT.BUSINESS_HOURS.RE_ENGAGEMENT.SELECT_TEMPLATE')"
                  :type="'button'"
                  @click="showTemplatePicker = true"
                  class="add-button"
                  style="margin-top: 0.5rem;" />

                <div v-if="showTemplatePicker" class="template-picker-container">
                  <templates-picker
                    :inbox-id="inbox.id"
                    :contact-id="null"
                    @onSelect="onTemplateSelect" />
                  <woot-submit-button
                    button-text="Cancelar"
                    :type="'button'"
                    @click="showTemplatePicker = false"
                    class="add-button"
                    style="margin-top: 0.5rem;" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <woot-submit-button :button-text="$t('INBOX_MGMT.BUSINESS_HOURS.UPDATE')" :loading="uiFlags.isUpdating"
          :disabled="hasError || isMoreThanMax" />
      </form>
    </settings-section>
  </div>
</template>

<script>
import SettingsSection from 'dashboard/components/SettingsSection';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor';
import { MESSAGE_MAX_LENGTH } from 'shared/helpers/MessageTypeHelper';
import alertMixin from 'shared/mixins/alertMixin';
import inboxMixin from 'shared/mixins/inboxMixin';
import { mapGetters } from 'vuex';
import getUuid from '../../../../../../widget/helpers/uuid';
import {
  defaultTimeSlot,
  timeSlotParse,
  timeSlotTransform,
  timeZoneOptions
} from '../helpers/businessHour';
import BusinessDay from './BusinessDay';
import CustomBusinessDay from './CustomBusinessDay';
import TemplatesPicker from 'dashboard/components/widgets/conversation/WhatsappTemplates/TemplatesPicker';

const DEFAULT_TIMEZONE = {
  label: 'America/Los_Angeles',
  key: 'America/Los_Angeles',
};

export default {
  components: {
    SettingsSection,
    BusinessDay,
    WootMessageEditor,
    CustomBusinessDay,
    TemplatesPicker,
  },
  mixins: [alertMixin, inboxMixin],
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isBusinessHoursEnabled: false,
      isBusinessHoursDisableBot: false,
      isDefineBusinessHoursEnabled: false,
      isDefineCustomBusinessHoursEnabled: false,
      enableWeekly: false,
      unavailableMessage: '',
      timeZone: DEFAULT_TIMEZONE,
      dayNames: {
        0: 'Sunday',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
      },
      timeSlots: [...defaultTimeSlot],
      customTimeSlots: [],
      deletedCustomTimeSlots: [],
      nextCustomSlotId: 1,
      reEngagementActive: false,
      reEngagementMessage: '',
      reEngagementMessageTemplate: null,
      showTemplatePicker: false,
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
    hasError() {
      if (!this.isBusinessHoursEnabled) return false;
      return this.timeSlots.concat(this.customTimeSlots).some(slot => slot.from && !slot.valid);
    },
    isMoreThanMax() {
      return this.unavailableMessage.length > MESSAGE_MAX_LENGTH.WORKING_TIME;
    },
    isCloseToLimit() {
      return this.unavailableMessage.length > MESSAGE_MAX_LENGTH.WORKING_TIME - 50;
    },
    charToLimit() {
      return MESSAGE_MAX_LENGTH.WORKING_TIME - this.unavailableMessage.length;
    },
    charOverLimit() {
      return this.unavailableMessage.length - MESSAGE_MAX_LENGTH.WORKING_TIME;
    },
    timeZones() {
      return [...timeZoneOptions()];
    },
    isRichEditorEnabled() {
      if (
        this.isATwilioChannel ||
        this.isATwitterInbox ||
        this.isAFacebookInbox
      )
        return false;
      return true;
    },
    isWhatsAppInbox() {
      return this.inbox?.channel_type === 'Channel::Whatsapp';
    },
  },
  methods: {
  sanitizeMessage(message) {
    if (!message) return '';
    return message.replace(/!\[(.*?)\]\(.*?\)/g, '$1');
  },
  setDefaults() {
    const {
      working_hours_enabled: isEnabled = false,
      working_hours_disable_bot: isDisableBot = false,
      out_of_office_message: unavailableMessage,
      working_hours: timeSlots = [],
      timezone: timeZone,
      enable_weekly: enableWeekly = false,
      re_engagement_active: reEngagementActive = false,
      re_engagement_message: reEngagementMessage = '',
      re_engagement_message_template: reEngagementMessageTemplate = null,
    } = this.inbox;


    const isDefaultTimeSlots = !timeSlots.filter(s => !s.custom_date).length;
    const slots = timeSlotParse(timeSlots);
    this.isBusinessHoursEnabled = isEnabled;
    this.isBusinessHoursDisableBot = isDisableBot;
    this.enableWeekly = enableWeekly;


    const currentSlots = slots.filter(s => !s.customDate);
    const currentCustomSlots = slots.filter(s => s.customDate).map(cs => ({ ...cs}));
    this.isDefineBusinessHoursEnabled = enableWeekly && !isDefaultTimeSlots;
    this.isDefineCustomBusinessHoursEnabled = isEnabled && !!currentCustomSlots.length;


    this.unavailableMessage = unavailableMessage || '';
    this.timeSlots = currentSlots;
    this.customTimeSlots = currentCustomSlots;
    this.timeZone =
      this.timeZones.find(item => timeZone === item.value) ||
      DEFAULT_TIMEZONE;
    this.reEngagementActive = reEngagementActive;
    this.reEngagementMessage = reEngagementMessage;
    this.reEngagementMessageTemplate = reEngagementMessageTemplate;
  },
  handleDefineBusinessHoursToggle() {
    if (!this.isDefineBusinessHoursEnabled) {
      this.timeSlots = [...defaultTimeSlot];
    }
  },
  onSlotUpdate(slotIndex, slotData) {
    this.timeSlots = this.timeSlots.map(item =>
      item.day === slotIndex ? slotData : item
    );
  },
  syncCustomSlotIds() {
    const bankSlots = (this.inbox.working_hours || []).filter(s => s.custom_date);
    this.customTimeSlots = this.customTimeSlots.map(local => {
      const match = bankSlots.find(
        b => b.day === local.day && b.month === local.month && b.year === local.year
      );
      return match ? { ...local, id: match.id } : local;
    });
  },
  onCustomSlotDelete(customSlotId) {
    this.deletedCustomTimeSlots.push(this.customTimeSlots.find(item => item.id === customSlotId));
    this.customTimeSlots = this.customTimeSlots.filter(item => item.id !== customSlotId);
  },
  onCustomSlotUpdate(customSlotId, slotData) {
    this.customTimeSlots = this.customTimeSlots.map(item =>
      item.id === customSlotId ? { ...item, ...slotData } : item
    );
  },
  addCustomTimeSlot(e) {
    this.customTimeSlots.push({
      id: getUuid(),
      dayName: '',
      from: '',
      to: '',
      valid: false,
      custom_date: true,
    });
    e.preventDefault();
  },
  onTemplateSelect(template) {
    this.reEngagementMessageTemplate = {
      template_params: {
        name: template.name,
        category: template.category,
        language: template.language,
        components: template.components,
        processed_params: {}
      }
    };
    this.showTemplatePicker = false;
  },
  clearTemplate() {
    this.reEngagementMessageTemplate = null;
  },
  async updateInbox() {
    try {
      let finalWorkingHours = [];
      if (!this.enableWeekly) {
        finalWorkingHours = this.timeSlots.map(slot => ({
          ...slot,
          openAllDay: true,
          open_all_day:true
        }));
      } else {
        finalWorkingHours = [...this.timeSlots];
      }
      const workingHours = timeSlotTransform(finalWorkingHours,false,this.enableWeekly);
      const customWorkingHours = this.isDefineCustomBusinessHoursEnabled ? timeSlotTransform(this.customTimeSlots, true) : [];
      const deletedCustomWorkingHours = timeSlotTransform(
        !this.isDefineCustomBusinessHoursEnabled
          ? [...this.customTimeSlots, ...this.deletedCustomTimeSlots]
          : this.deletedCustomTimeSlots,
        true);
      const payload = {
        id: this.inbox.id,
        formData: false,
        working_hours_enabled: this.isBusinessHoursEnabled,
        working_hours_disable_bot: this.isBusinessHoursDisableBot,
        out_of_office_message: this.sanitizeMessage(this.unavailableMessage),
        to_reset_working_hours: !this.isDefineBusinessHoursEnabled,
        working_hours: workingHours.concat(customWorkingHours),
        deleted_custom_working_hours: deletedCustomWorkingHours,
        timezone: this.timeZone.value,
        enable_weekly: this.enableWeekly,
        re_engagement_active: this.reEngagementActive,
        re_engagement_message: this.sanitizeMessage(this.reEngagementMessage),
        re_engagement_message_template: this.reEngagementMessageTemplate,
        channel: {},
      };
      await this.$store.dispatch('inboxes/updateInbox', payload);
      this.deletedCustomTimeSlots = [];
      this.showAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
    } catch (error) {
      this.showAlert(this.$t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE'));
    }
    await this.$nextTick();
    this.syncCustomSlotIds();
  },
},
  mounted() {
    this.setDefaults();
  },
};
</script>

<style lang="scss" scoped>
.timezone-input-wrap {
  max-width: 60rem;

  &::v-deep .multiselect {
    margin-top: var(--space-small);
  }
}

.unavailable-input-wrap {
  max-width: 60rem;

  textarea {
    min-height: var(--space-jumbo);
    margin-top: var(--space-small);
  }
}

.business-hours-wrap {
  margin-bottom: var(--space-medium);
}

.message-error {
  color: var(--r-600);
}

.separator {
  padding-top: 10px;
  border-top: 1px solid var(--color-border-light);
}

.message-length {
  color: var(--s-600);
}

.richtext {
  padding: 0 var(--space-normal);
  border-radius: var(--border-radius-normal);
  border: 1px solid var(--color-border);
  margin: 0 0 var(--space-normal);
}

.add-button {
  background-color: #e0e0e0;
  color: #333;
  margin-top: var(--space-normal);
}

.template-selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--s-50);
  border: 1px solid var(--s-100);
  border-radius: var(--border-radius-normal);
  padding: var(--space-small) var(--space-normal);
  margin-top: var(--space-small);
}

.template-info {
  display: flex;
  flex-direction: column;
  gap: var(--space-micro);
}

.template-lang {
  font-size: var(--font-size-mini);
  color: var(--s-600);
}

.clear-template-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: var(--space-micro);
  color: var(--r-600);

  &:hover {
    color: var(--r-700);
  }
}

.template-picker-container {
  margin-top: var(--space-normal);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-normal);
  padding: var(--space-normal);
  background-color: var(--color-background);
  max-height: 40rem;
  overflow-y: auto;
}
</style>
